// Vendor
window.$ = window.jQuery = require('jquery');
window.bootstrap = require('bootstrap');
window.moment = require('moment');
window.Popper = require('@popperjs/core');
window.Swal = require('sweetalert2/dist/sweetalert2');

require('bootstrap');
require('datatables.net-bs5');
require('datatables.net-responsive-bs5');
require('daterangepicker');

// Custom Override (Bootstrap 5)
require('@veximus/input-search');

// Core
require('./utilities');
require('./portal/base');
